import { Component, inject } from '@angular/core'

import { BaseDialogComponent } from '@hyperkit'

import { SupportService } from '../../../services/support.service'

@Component({
  standalone: false,
  selector: 'talk-to-cyborg-dialog',
  templateUrl: './talk-to-cyborg-dialog.component.html',
  styleUrls: ['./talk-to-cyborg-dialog.component.scss'],
})
export class TalkToCyborgDialogComponent extends BaseDialogComponent<
  unknown,
  boolean
> {
  supportService = inject(SupportService)

  public submitted = false
  public error: string
  public isSmallScreen = false

  public talkToCyborg(): void {
    this.dialogRef.close(true)
  }

  public onClose(): void {
    this.dialogRef.close()
  }

  protected initializeOptions(): void {
    this.options = { headerText: 'Talk To Intel 471' }
  }
}
